import { jsPDF } from "jspdf";

export const drawPdfConfidentialBanner = (document: jsPDF, y: number) => {
  const width = document.internal.pageSize.getWidth() - 28;
  document.setFillColor(254, 226, 226);
  document.setTextColor(153, 27, 27);
  document.setFont("helvetica", "bold");
  document.setFontSize(9);
  document.roundedRect(14, y, width, 9, 1, 1, "F");
  document.text("CONFIDENTIAL", 18, y + 6);
  return y + 14;
};
